var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.left},[_c('user-info',{attrs:{"hasNav":_vm.hasNav}})],1),_vm._v(" "),_c('a',{class:_vm.$style.appLink,attrs:{"href":_vm.appUrl,"target":"_blank","title":"Open Jiminny app"}},[_c('img',{attrs:{"src":_vm.jiminnyLogo,"alt":"Jiminny Logo"}})]),_vm._v(" "),_c('div',{class:_vm.$style.right})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c4b934","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logged-in-layout/header-top/header-top.vue
// module id = TeQx
// module chunks = 1